import { render, staticRenderFns } from "./WrSectionTitle.vue?vue&type=template&id=83597236&"
import script from "./WrSectionTitle.vue?vue&type=script&lang=js&"
export * from "./WrSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./WrSectionTitle.vue?vue&type=style&index=0&id=83597236&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports